(function hamburgerToggle() {
	const hamburger = document.getElementById("hamburger");
	const menuPage = document.getElementById("main-menu");

	hamburger.addEventListener("click", () => {
		const isOpen = menuPage.classList.toggle("expanded");
		hamburger.classList.toggle("expanded");
		hamburger.setAttribute("aria-expanded", isOpen);
		// Actualiza el aria-label para accesibilidad
		hamburger.setAttribute("aria-label", isOpen ? "Cerrar menú" : "Abrir menú");
	});
})();
